module.exports = __webpack_public_path__ + "static/media/logo-white.8f645315.svg";